// extracted by mini-css-extract-plugin
export default {"error":"error___i69B"};